package uz.ferro.erp.feature.appuser.ui

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.material.*
import mui.material.Size

import mui.material.styles.TypographyVariant
import mui.system.sx
import react.*
import react.dom.events.ChangeEvent
import react.dom.onChange
import uz.ferro.erp.feature.alert.AlertManagerContext
import uz.ferro.erp.feature.appuser.data.SalesPointRepository
import uz.ferro.erp.feature.appuser.data.UserRepository
import uz.ferro.erp.feature.appuser.model.*
import uz.ferro.erp.feature.salesperson.data.SalesPersonRepository
import uz.ferro.erp.feature.salesperson.model.SalesPersonDto
import uz.ferro.erp.ui.VerticalLayout
import web.cssom.*
import web.html.HTMLInputElement
import web.html.InputType

external interface AddProps : Props {
    var modalOpen: Boolean
    var userId: Long?
    var onCloseModal: () -> Unit

}

val UserDetailsPage = FC<AddProps> { props ->
    val userId = props.userId
    var modalOpen by useState(props.modalOpen)
    val alertManager = useContext(AlertManagerContext)

    // filter props
    var fullName by useState("")
    var login by useState("")
    var password by useState("")
    var role by useState("")
    var sapUser by useState("")
    var salesPoint: SalesPointDto? by useState()
    var salesPerson: SalesPersonDto? by useState()
    var active by useState(false)
    var permissions by useState<List<UserPermissionDto>>(emptyList())

    // data
    var user by useState<UserDto?>(null)
    var salesPoints by useState<List<SalesPointDto>>(emptyList())
    var salesPersons by useState<List<SalesPersonDto>>(emptyList())

    fun loadData() {
        MainScope().launch {
            try {
                if(userId != null) {
                    user = UserRepository.getUser(userId)
                }
                salesPoints = SalesPointRepository.getSalesPoints()
                salesPersons = SalesPersonRepository.getSalesPersons()
            } catch (e: Exception) {
                console.error(e)
            }
        }
    }

    useEffectOnce {
        console.log("User details page loaded with userId: $userId")
        loadData()
        permissions = Permission.entries.map { p -> UserPermissionDto(id = null, name = p.name, isAllowed = false) }
    }

    useEffect(user) {
        if(user != null) {
            fullName = user?.name.orEmpty()
            login = user?.username.orEmpty()
            password = user?.password.orEmpty()
            role = if (user?.role?.id == 3L) "Sotuv" else if (user?.role?.id == 4L) "Distributsiya" else ""
            sapUser = user?.sapEmployeeName.orEmpty()
            salesPoint = user?.salesPoint
            salesPerson = user?.salesPerson
            active = user?.disabled?.not() ?: false
            permissions = user?.permissions ?: emptyList()
        }
    }

    VerticalLayout {
        sx {
            width = 600.px
            margin = Auto.auto
            padding = 24.px
            display = Display.flex
            flexDirection = FlexDirection.column
            backgroundColor = Color("#fff")
            gap = 16.px
        }

        Typography {
            variant = TypographyVariant.h5
            +"Foydalanuvchi"
        }

        TextField {
            fullWidth = true
            error = fullName.isBlank()
            placeholder = "To'liq ismi"
            size = Size.small
            value = fullName
            onChange = { event ->
                event as ChangeEvent<HTMLInputElement>
                fullName = event.target.value
            }
        }

        TextField {
            fullWidth = true
            error = login.isBlank()
            required = true
            placeholder = "Login"
            size = Size.small
            value = login
            onChange = { event ->
                event as ChangeEvent<HTMLInputElement>
                login = event.target.value
            }
        }

        TextField {
            fullWidth = true
            error = password.isBlank() && user == null
            required = true
            placeholder = "Parol"
            size = Size.small
            value = password
            type = InputType.password
            autoComplete = "off"

            onChange = { event ->
                event as ChangeEvent<HTMLInputElement>
                password = event.target.value
            }
        }

        FormControl {
            size = Size.small
            fullWidth = true
            error = role.isBlank()
            InputLabel {
                +"Foydalanuvchi turi"
                shrink = true
            }
            Select {
                displayEmpty = true
                value = role
                label = ReactNode("Foydalanuvchi turi")
                size = Size.small

                onChange = { event, _ ->
                    role = event.target.value
                }

                MenuItem {
                    value = "Sotuv"
                    +"Sotuv"
                }
                MenuItem {
                    value = "Distributsiya"
                    +"Distributsiya"
                }
            }
        }

        TextField {
            fullWidth = true
            hidden = true
            placeholder = "Distributsiya hodimi (SAP)"
            size = Size.small
            value = sapUser
            onChange = { event ->
                event as ChangeEvent<HTMLInputElement>
                sapUser = event.target.value
            }
        }

        FormControl {
            size = Size.small
            fullWidth = true
            error = (salesPoint == null)
            InputLabel {
                +"Sotuv joyi"
                shrink = true
            }
            Select {
                displayEmpty = true
                value = salesPoint?.id.orEmpty()
                label = ReactNode("Sotuv joyi")
                size = Size.small

                onChange = { event, _ ->
                    salesPoint = salesPoints.find { sPoint ->
                        sPoint.id == event.target.value
                    }
                }

                salesPoints.forEach { sp ->
                    MenuItem {
                        value = sp.id
                        +sp.id
                    }
                }
            }
        }

        FormControl {
            size = Size.small
            fullWidth = true
            InputLabel {
                +"Sotuv menejeri"
                shrink = true
            }
            Select {
                displayEmpty = true
                value = salesPerson?.name.orEmpty()
                label = ReactNode("Sotuv menejeri")
                size = Size.small

                onChange = { event, _ ->
                    salesPerson = salesPersons.find { sPerson ->
                        sPerson.name == event.target.value
                    }
                }

                salesPersons.forEach { sp ->
                    MenuItem {
                        value = sp.name
                        +sp.name
                    }
                }
            }
        }

        FormControl {
            size = Size.small
            fullWidth = true
            InputLabel {
                +"Holati"
                shrink = true
            }
            Select {
                displayEmpty = true
                displayEmpty = true
                value = if (active) "Aktiv" else "Noaktiv"
                label = ReactNode("Holati")
                size = Size.small

                onChange = { event, _ ->
                    active = (event.target.value == "Aktiv")
                }

                MenuItem {
                    value = "Aktiv"
                    +"Aktiv"
                }
                MenuItem {
                    value = "Noaktiv"
                    +"Noaktiv"
                }
            }
        }

        for(permission in Permission.entries) {
            FormControlLabel {
                sx {
                    width = Length.maxContent
                }
                control = Checkbox.create {
                    checked = permissions.any { p -> p.name == permission.name && p.isAllowed }
                    onChange = { _, checked ->
                        permissions.firstOrNull { p -> p.name == permission.name }?.isAllowed = checked
                        permissions = permissions.toList()
                    }
                }
                label = ReactNode(permission.displayName.orEmpty())
            }
        }

        Button {
            variant = ButtonVariant.contained
            fullWidth = true
            +"SAQLASH"
            onClick = {
                if (fullName.isBlank() || login.isBlank() ||
                    (user == null && password.isBlank()) ||
                    role.isBlank() || salesPoint == null) {
                    alertManager.showError("Iltimos barcha kerakli maydonlarni to'ldiring!")
                } else {
                    // handle save logic
                    modalOpen = false

                    MainScope().launch {
                        val userDto =
                        UserDto(
                            id = user?.id,
                            sapEmployeeId = null,
                            name = fullName,
                            username = login,
                            password = password,
                            role = if (role == "Sotuv") Role(id = 3L, name = role) else if (role == "Distributsiya") Role(id = 4L, name = role) else null,
                            permissions = permissions,
                            disabled = active.not(),
                            salesPoint = salesPoint,
                            salesPerson = salesPerson,
                            sapEmployeeName = sapUser,
                        )

                        val saved = if (userDto.id == null) UserRepository.addUser(userDto) else UserRepository.updateUser(userDto)

                        if(saved != null) {
                            props.onCloseModal.invoke()
                            alertManager.showSuccess("Saqlandi")
                        }
                    }
                }
            }
        }
    }
}
